import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ResidentialRemodelingHero from './components/ResidentialRemodelingHero';
import ResidentialRemodelingServices from './components/ResidentialRemodelingServices';
import RemodelingTypesElPaso from './components/RemodelingTypesElPaso';
import ContractorDirectory from './components/ContractorDirectory';
import ComparisonChecklist from './components/ComparisonChecklist';
import ResidentialRemodelingFAQ from './components/ResidentialRemodelingFAQ';

export default function ResidentialRemodelingPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      <main>
        <ResidentialRemodelingHero />
        <ResidentialRemodelingServices />
        <RemodelingTypesElPaso />
        <ContractorDirectory />
        <ComparisonChecklist />
        <ResidentialRemodelingFAQ />
      </main>
      <Footer />
    </div>
  );
}
